<template>
<div>
    <a-row type="flex" align="middle" class="networking-row" v-if="!meeting">
      <a-col :span="24">No currently runnning meetings
      </a-col>
    </a-row>
    <a-row type="flex" align="middle" class="networking-row"  v-if="meeting.dialNumber[0] == 'HRWeek'">
      <a-col :span="isMobile ? '12' : '10'">
        <p class="networking-name">{{ meeting.meetingName[0] }}</p>
      </a-col>
      <a-col :span="10" v-if="!isMobile">
         <div v-for="attendeeImage in this.attendeesImages" :key="attendeeImage.attendeeName" style="display:inline-block">     
        <router-link :to="userProfileLink(attendeeImage.attendeeName, attendeeImage.id)">
          <a-tooltip>
            <template slot="title">
              {{attendeeImage.attendeeName}}
            </template>
           <a-avatar shape="circle" :src="attendeeImage.attendeeImage" icon="user" :size="40" style="margin-right:10px"/>
          </a-tooltip>
       </router-link>    
        </div>
      </a-col>
      <a-col :span="isMobile ? '12' : '4'">
        <a-button type="default" icon="export" class="networking-button" @click="joinMeeting" style="float:right">Enter the room</a-button>
      </a-col>
    </a-row>
</div>
</template>

<script>
import isMobileMixin from "../../mixins/isMobileMixin";
import api from "../../api";
import axios from 'axios';
export default {
  props: {
    meeting: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      userName: 'dummyName',
      userType: 'user',
      meetingId: 'dummyMeeting',
      usrId: null,
      userId: null,
      attendees: [],
      attendeesImages: [],
    };
  },
  mixins: [isMobileMixin],
  computed: {

  },
  
  watch: {
    meeting: function () {
        this.getMeetingInfo();
      },
  },

  created() {
    
},
mounted() {
    this.userId = localStorage.getItem('usr_id');
    //this.getUserName(this.userId);
    this.getMeetingInfo();
    this.meetingId = this.meeting.meetingID[0];
},
  methods: {
    
     /*  async getUserName(userId){
        await api.getProfile(userId).then((response) => {
          this.usrId = response.data.user.usr_id;
          this.userName = response.data.user.firstname + ' ' + response.data.user.usr_lastname; // + '+' + response.data.user.usr_lastname
          this.userType = response.data.user.type;
        })
      }, */

      async getUserAvatar(attendeeId, attendeeName) {
      try {
        this.startLoading();
        let image = await this.getImageUsrId(attendeeId);
        this.attendeesImages.push({
          id: attendeeId,
          attendeeName: attendeeName,
          attendeeImage: image
        });

      } catch (error) {
        this.handleError(error);
      } finally {
        // if stopLoading is not handled in finally block, catch needs to call stopLoading() as well
        this.stopLoading();
      }
      const result = [];
      const map = new Map();
      for (const item of this.attendeesImages) {
          if(!map.has(item.attendeeName)){
              map.set(item.attendeeName, true);    // set any value to Map
              result.push({
                  id: item.id,
                  attendeeName: item.attendeeName,
                  attendeeImage: item.attendeeImage
              });
          }
      }
      this.attendeesImages = result;
    },

      getMeetingInfo(){
        if(this.meeting.attendees[0].attendee){
      this.attendees = this.meeting.attendees[0].attendee;
      this.attendees.forEach(attendee => {
        this.getUserAvatar(attendee.userID[0], attendee.fullName[0]);
       // this.attendeesImages.push(attendeeImage);
      });
       //await this.getImageUsdId(data.usd_id)
    }
      },

      /* Join the meeting */
    async joinMeeting(){
        //let joinUrl = 'https://hrweek.collectivibe.com/api/users/bbb?action=join&user=' + this.userName+'&meeting=' + this.meetingId + '&type=' + this.userType + '&usr_id=' + this.usrId;
        let currentSid = localStorage.getItem("sid");
        let joinUrl =  process.env.VUE_APP_API_URL + '/users/bbb?action=join&sid=' + currentSid +'&meeting=' + this.meetingId;
        await axios.get(joinUrl).then((response) => {
         let responseJoinURL = JSON.parse(response.request.response).joinUrl;
         window.open(responseJoinURL, '_blank').focus();
         });
    },
     userProfileLink(attendeeName, id) {
       let realName = attendeeName.split(', ')[0];
       let nameFormatted = realName.replaceAll(' ', '-');
      return (
        "/profile/" + nameFormatted + "-" + id
      );
    },
  }
};
</script>

<style lang="scss" scoped>

</style>